import React from 'react';

import dummyQRCode from '@/assets/dummyQRCode.png';

import { Container } from './styles';

const QRCodeContent = () => {
  return (
    <Container>
      <h2 className="title">置物櫃認證 QR Code</h2>
      <div className="bar" />
      <div className="qrCode">
        {/* TODO: 介接實際QRCode */}
        <img src={dummyQRCode} alt="QR Code" />
        <p className="qrCode__text">對準掃瞄器以開啟無人置物櫃</p>
      </div>
    </Container>
  );
};

export default QRCodeContent;
